import React, { useMemo, useState, useEffect } from "react";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SmsIcon from "@mui/icons-material/Sms";
import DeleteIcon from "@mui/icons-material/Delete";
import { ToastContainer } from "react-toastify";
import NumberInput from "../../Components/PhoneInput/phoneInput";
import CloseIcon from "@mui/icons-material/Close";
import { FormControlLabel, Radio } from "@mui/material";

const InvoiceForm = ({ data, method, onGenerate }) => {
  const [showNewClient, setShowNewClient] = useState(false);
  const CLIENT_ADD_VALUE = "__add_client__";

  const {
    clientData = [],
    teamMember = [],
    serviceList = [],
    branchData = [],
    formData = { services: [], sendType: [] },
    visitType = [],
    errors = {},
    spinner = false,
    // offerList
    offerMap,
    userData,
    currencyName,
  } = data || {};



  const {
    handleChange,
    setFormData,
    setErrors,
    calculateServiceGST,
    clearError,
    offerListInvoice,
  } = method || {};

  const formatMoney = (n) =>
    `${currencyName}${Number(n || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

  const removeErrorKey = (key) => {
    if (!key) return;
    if (typeof clearError === "function") {
      clearError(key);
      return;
    }
    setErrors?.((prev) => {
      if (!prev?.[key]) return prev;
      const copy = { ...prev };
      delete copy[key];
      return copy;
    });
  };

  const clearServiceRequiredError = () => {
    if (errors?.services) {
      setErrors?.((prev) => {
        const copy = { ...prev };
        delete copy.services;
        return copy;
      });
    }
  };

  const clearServiceStaffError = (serviceId) => {
    if (errors?.serviceStaffMap?.[serviceId]) {
      setErrors?.((prev) => {
        const copy = { ...prev };
        const map = { ...(copy.serviceStaffMap || {}) };
        delete map[serviceId];
        if (Object.keys(map).length === 0) delete copy.serviceStaffMap;
        else copy.serviceStaffMap = map;
        return copy;
      });
    }
  };

  const recomputeService = (serviceId) => {
    setFormData((prev) => {
      const updated = (prev.services || []).map((s) => {
        if (s.serviceId !== serviceId) return s;
        const calc = calculateServiceGST ? calculateServiceGST(s) : {};
        return { ...s, ...calc };
      });
      return { ...prev, services: updated };
    });
  };

  const onToggleService = (serviceId, categoryId) => {
    const serviceIndex = (formData.services || []).findIndex(
      (s) => s.serviceId === serviceId
    );
    // offerListInvoice(serviceId);
    if (typeof offerListInvoice === "function") {
      offerListInvoice(serviceId);
    }

    if (serviceIndex > -1) {
      setFormData((prev) => ({
        ...prev,
        services: (prev.services || []).filter(
          (s) => s.serviceId !== serviceId
        ),
      }));
      clearServiceStaffError(serviceId);
      return;
    }

    const service = serviceList
      .find((cat) => cat.categoryId === categoryId)
      ?.servicedetails?.find((s) => s.serviceId === serviceId);

    if (!service) return;

    clearServiceRequiredError();

    const amount = Number(service.fixedAmount || 0);
    const gstPercentFromApi = Number(service.gst || 0);
    const gstStatusFromApi = service.isGSTInclude ? "INCLUDE" : "EXCLUDE";


    const newRow = {
      serviceId: service.serviceId,
      staffId: "",
      serviceAmount: amount,
      gstPercent: gstPercentFromApi,
      GST: gstStatusFromApi,
      basePrice: 0,
      gstPrice: 0,
      gstValue: 0,
      finalAmount: 0,
      selectedOffer: null,
      offerId: null,
      serviceName: service.serviceName,
    };

    const calc = calculateServiceGST ? calculateServiceGST(newRow) : {};
    setFormData((prev) => ({
      ...prev,
      services: [...(prev.services || []), { ...newRow, ...calc }],
    }));
  };

  const updateServiceDetail = (serviceId, field, value) => {
    setFormData((prev) => ({
      ...prev,
      services: (prev.services || []).map((s) =>
        s.serviceId === serviceId ? { ...s, [field]: value } : s
      ),
    }));
  };

  const updateServiceOffer = (serviceId, offerId) => {
    const rowOffers = offerMap?.[serviceId] || [];
    const offer = rowOffers.find((o) => o._id === offerId);

    setFormData((prev) => ({
      ...prev,
      services: (prev.services || []).map((s) => {
        if (s.serviceId !== serviceId) return s;

        return {
          ...s,
          selectedOffer: offer || null,
          offerId: offerId || null,
          serviceName: getServiceName(serviceId),
        };
      }),
    }));

    setTimeout(() => recomputeService(serviceId), 0);
  };


  const getServiceName = (serviceId) => {
    for (const category of serviceList) {
      const service = category.servicedetails?.find(
        (s) => s.serviceId === serviceId
      );
      if (service) return service.serviceName;
    }
    return serviceId;
  };

  
// Add this helper function at the top of your InvoiceForm component
// const calculateAdditionalDiscount = (subTotal, discountType, discountValue) => {
//   if (!discountValue || discountValue <= 0) return 0;
  
//   if (discountType === 'FLAT') {
//     return Math.min(Number(discountValue), subTotal);
//   } else if (discountType === 'PERCENTAGE') {
//     return (subTotal * Number(discountValue)) / 100;
//   }
//   return 0;
// };


const totals = useMemo(() => {
  const services = formData.services || [];



 let newGst = 0,newFinalAmount = 0, newBaseAmount=0;

   let totalGst = 0,
   subTotal =0

  for (const service of services) {
    totalGst += service.gstValue
    subTotal+=service.basePrice
  }
    const totalAmount = subTotal + totalGst;


  for (const service of services) {

    if(formData.additionalOffer.discountType == 'FLAT'){

            console.log(service.finalAmount,formData.additionalOffer.discount,totalAmount)


    const Ratio = (service.finalAmount)/totalAmount

    const additionalDiscount = formData.additionalOffer?.discount * Ratio

    const additionalNewPrice  =  service.finalAmount - additionalDiscount
    
    


   const gstper = service.gstPercent / 100;
      service.additionalBasePrice =additionalNewPrice / (1 + gstper);
      service.additionalGstValue = service.finalAmount - additionalNewPrice;
      service.additionalFinalAmount = additionalNewPrice;
      service.additionalGstValue = additionalNewPrice - service.additionalBasePrice;



 newGst+=service.additionalGstValue
 newFinalAmount+=service.additionalFinalAmount
 newBaseAmount+=service.additionalBasePrice

    }else{


const discountPercent = formData.additionalOffer?.discount || 0;

const percentageDiscount = (discountPercent / 100) * totalAmount;

const ratio = service.finalAmount / totalAmount;

const additionalDiscount = percentageDiscount * ratio;

const additionalNewPrice = service.finalAmount - additionalDiscount;

const gstper = service.gstPercent / 100;
service.additionalBasePrice = additionalNewPrice / (1 + gstper);
service.additionalFinalAmount = additionalNewPrice;
service.additionalGstValue =
  service.additionalFinalAmount - service.additionalBasePrice;

newGst += service.additionalGstValue;
newFinalAmount += service.additionalFinalAmount;
newBaseAmount += service.additionalBasePrice;

    }
    
  }





// let discountedSubTotal
//     if(formData.discountType == 'FLAT'){
//       discountedSubTotal = totalAmount - formData.additionalOffer?.discount;
//     }else{
//      const percentageOff =  (formData.additionalOffer?.discount/100)*totalAmount
     
//      discountedSubTotal = totalAmount - percentageOff;
//     }

//   let additionalDiscount =0
let discountedSubTotal = totalAmount;
let additionalDiscount = 0;

if (formData.additionalOffer?.discount > 0) {
  if (formData.additionalOffer.discountType === 'FLAT') {
    additionalDiscount = Math.min(
      Number(formData.additionalOffer.discount),
      totalAmount
    );
  } else if (formData.additionalOffer.discountType === 'PERCENTAGE') {
    additionalDiscount =
      (Number(formData.additionalOffer.discount) / 100) * totalAmount;
  }

  discountedSubTotal = totalAmount - additionalDiscount;
}
  
  return { 
    subTotal:newBaseAmount, 
    discountedSubTotal,
    additionalDiscount,
    totalGst : newGst, 
    totalAmount :newFinalAmount
  };
}, [formData.services, formData.additionalOffer]);


useEffect(() => {
  setFormData((prev) => ({
    ...prev,
    subTotal: totals.discountedSubTotal,
    totalGst: totals.totalGst,
    totalAmount: totals.totalAmount,
    additionalOffer: {
      ...prev.additionalOffer,
      discountPrice: totals.additionalDiscount,
    }
  }));
}, [totals.discountedSubTotal, totals.totalGst, totals.totalAmount, totals.additionalDiscount]);

  const isTypeSelected = (type) =>
    (formData.sendType || []).some((x) => x.type === type && x.isSelected);

  const toggleSendType = (type) => {
    setFormData((prev) => {
      const next = (prev.sendType || []).map((x) => {
        if (x.type !== type) return x;
        return { ...x, isSelected: !x.isSelected };
      });
      return { ...prev, sendType: next };
    });

    removeErrorKey("sendType");
    if (type === "EMAIL") removeErrorKey("email");
  };

  const updateEmailInSendType = (email) => {
    setFormData((prev) => ({
      ...prev,
      sendType: (prev.sendType || []).map((x) =>
        x.type === "EMAIL" ? { ...x, email } : x
      ),
    }));
    removeErrorKey("email");
  };

  const toDateTimeLocal = (date) => {
    const pad = (n) => String(n).padStart(2, "0");
    const yyyy = date.getFullYear();
    const mm = pad(date.getMonth() + 1);
    const dd = pad(date.getDate());
    const hh = pad(date.getHours());
    const min = pad(date.getMinutes());
    return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
  };

  useEffect(() => {
    const hasStart = !!formData?.startDateTime;
    const hasEnd = !!formData?.endDateTime;

    if (hasStart && hasEnd) return;

    const now = new Date();
    const end = new Date(now.getTime() + 30 * 60 * 1000);

    setFormData((prev) => ({
      ...prev,
      startDateTime: prev.startDateTime || toDateTimeLocal(now),
      endDateTime: prev.endDateTime || toDateTimeLocal(end),
    }));

    removeErrorKey("startDateTime");
    removeErrorKey("endDateTime");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.startDateTime, formData?.endDateTime]);

  const parseLocalDateTime = (v) => (v ? new Date(v) : null);

  const validateStartEnd = (startStr, endStr) => {
    const start = parseLocalDateTime(startStr);
    const end = parseLocalDateTime(endStr);

    if (start && end && end < start) {
      setErrors?.((prev) => ({
        ...prev,
        endDateTime: "End date & time should be greater than start date & time",
      }));
      return false;
    }

    removeErrorKey("endDateTime");
    return true;
  };

  const [serviceQuery, setServiceQuery] = useState("");

  const filteredServiceList = useMemo(() => {
    const q = (serviceQuery || "").trim().toLowerCase();
    if (!q) return serviceList;

    return (serviceList || [])
      .map((cat) => {
        const details = (cat.servicedetails || []).filter((s) =>
          (s.serviceName || "").toLowerCase().includes(q)
        );
        return { ...cat, servicedetails: details };
      })
      .filter((cat) => (cat.servicedetails || []).length > 0);
  }, [serviceList, serviceQuery]);

  const clearServiceOffer = (serviceId) => {
    setFormData((prev) => ({
      ...prev,
      services: (prev.services || []).map((s) =>
        s.serviceId === serviceId
          ? {
              ...s,
              selectedOffer: null,
              offerId: null,
              offerDiscount: 0,
              originalBasePrice: s.originalBasePrice || 0, // optional safe fallback
            }
          : s
      ),
    }));

    setTimeout(() => recomputeService(serviceId), 0);
  };

  // Reusable: allow digits only, no +/- , max N digits
 const digitsOnlyMax = (value, maxDigits = 2) =>
  String(value ?? "")
    .replace(/\D/g, "")      // keep digits only
    .slice(0, maxDigits);    // cap length

// Optional helper: block common invalid keys for numeric fields
 const blockNonNumericKeys = (e) => {
  const blocked = ["+", "-", "e", "E", ".", ","];
  if (blocked.includes(e.key)) e.preventDefault();
};

  if (!data || !method) return null;

  return (
    <>
      <ToastContainer />

      <div
        style={{
          background: "#fff",
          borderRadius: 10,
          padding: 18,
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
        }}
      >
        <div className="cus-form">
          <div className="row g-3">
            {/* Client */}
            <div className="col-md-6">
              <label className="form-label">
                Client <span className="text-danger">*</span>
              </label>

              <select
                className={`form-select form-control ${
                  errors.clientId ? "is-invalid" : ""
                }`}
                name="clientId"
                value={
                  showNewClient ? CLIENT_ADD_VALUE : formData.clientId || ""
                }
                onChange={(e) => {
                  const val = e.target.value;
                  removeErrorKey("clientId");

                  if (val === CLIENT_ADD_VALUE) {
                    setShowNewClient(true);
                    setFormData((prev) => ({
                      ...prev,
                      clientId: "",
                      clientName: "",
                      mobileNo: "",
                      sendType: (prev.sendType || []).map((x) => ({
                        ...x,
                        isSelected: false,
                        email: x.type === "EMAIL" ? "" : x.email,
                      })),
                    }));
                    removeErrorKey("clientName");
                    removeErrorKey("mobileNo");
                    removeErrorKey("email");
                    removeErrorKey("sendType");
                    return;
                  }

                  const selected = clientData.find((c) => c._id === val);
                  setShowNewClient(false);
                  setFormData((prev) => ({
                    ...prev,
                    clientId: val,
                    clientName: "",
                    mobileNo: "",
                    sendType: (prev.sendType || []).map((x) => {
                      if (x.type === "EMAIL")
                        return {
                          ...x,
                          isSelected: true,
                          email: selected?.email || "",
                        };
                      return x;
                    }),
                  }));
                  removeErrorKey("sendType");
                  if (selected?.email) removeErrorKey("email");
                }}
              >
                <option value="" disabled>
                  Select client
                </option>
                <option
                  value={CLIENT_ADD_VALUE}
                  style={{ fontWeight: "900", color: "#000" }}
                >
                  + Add New Client
                </option>
                {clientData.map((client) => (
                  <option key={client._id} value={client._id}>
                    {client.name}
                  </option>
                ))}
              </select>

              {errors.clientId && (
                <div className="invalid-feedback d-block">
                  {errors.clientId}
                </div>
              )}

              {showNewClient && (
                <div className="mt-3">
                  <div className="mb-2">
                    <input
                      type="text"
                      className={`form-control ${
                        errors.clientName ? "is-invalid" : ""
                      }`}
                      placeholder="Enter new client name"
                      value={formData.clientName || ""}
                      onChange={(e) => {
                        setFormData((prev) => ({
                          ...prev,
                          clientName: e.target.value,
                        }));
                        removeErrorKey("clientName");
                      }}
                    />
                    {errors.clientName && (
                      <div className="invalid-feedback d-block">
                        {errors.clientName}
                      </div>
                    )}
                  </div>
                  <div>
                    <NumberInput
                      width={false}
                      Require={false}
                      Name="mobileNo"
                      HandleChange={{
                        setFieldValue: (field, value) => {
                          setFormData((prev) => ({
                            ...prev,
                            [field]: value || "",
                          }));
                          removeErrorKey(field);
                        },
                      }}
                      Value={formData.mobileNo || ""}
                    />
                    {errors.mobileNo && (
                      <div className="invalid-feedback d-block">
                        {errors.mobileNo}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Branch */}
            <div className="col-md-6">
              <label className="form-label">
                Branch <span className="text-danger">*</span>
              </label>
              <select
                className={`form-select form-control ${
                  errors.branchId ? "is-invalid" : ""
                }`}
                name="branchId"
                value={formData.branchId || ""}
                onChange={(e) => {
                  handleChange(e);
                  removeErrorKey("branchId");
                }}
              >
                <option value="" disabled>
                  Select branch
                </option>
                {branchData.map((branch) => (
                  <option key={branch._id} value={branch._id}>
                    {branch.name}
                  </option>
                ))}
              </select>
              {errors.branchId && (
                <div className="invalid-feedback d-block">
                  {errors.branchId}
                </div>
              )}
            </div>

            {/* Start DateTime */}
            <div className="col-md-6">
              <label className="form-label">
                Start Date & Time <span className="text-danger">*</span>
              </label>
              <input
                type="datetime-local"
                className={`form-control ${
                  errors.startDateTime ? "is-invalid" : ""
                }`}
                name="startDateTime"
                value={formData.startDateTime || ""}
                onChange={(e) => {
                  handleChange(e);
                  removeErrorKey("startDateTime");
                  const nextStart = e.target.value;
                  validateStartEnd(nextStart, formData.endDateTime);
                  if (
                    formData.endDateTime &&
                    new Date(formData.endDateTime) < new Date(nextStart)
                  ) {
                    setFormData((prev) => ({
                      ...prev,
                      endDateTime: nextStart,
                    }));
                    removeErrorKey("endDateTime");
                  }
                }}
              />
              {errors.startDateTime && (
                <div className="invalid-feedback d-block">
                  {errors.startDateTime}
                </div>
              )}
            </div>

            {/* End DateTime */}
            <div className="col-md-6">
              <label className="form-label">
                End Date & Time <span className="text-danger">*</span>
              </label>
              <input
                type="datetime-local"
                className={`form-control ${
                  errors.endDateTime ? "is-invalid" : ""
                }`}
                name="endDateTime"
                value={formData.endDateTime || ""}
                onChange={(e) => {
                  const nextEnd = e.target.value;
                  if (
                    formData.startDateTime &&
                    new Date(nextEnd) < new Date(formData.startDateTime)
                  ) {
                    setErrors?.((prev) => ({
                      ...prev,
                      endDateTime:
                        "End date & time should be greater than start date & time",
                    }));
                    return;
                  }
                  handleChange(e);
                  removeErrorKey("endDateTime");
                }}
              />
              {errors.endDateTime && (
                <div className="invalid-feedback d-block">
                  {errors.endDateTime}
                </div>
              )}
            </div>
          </div>

          {/* Services Selection */}
          <div className="mt-4">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <label className="form-label">
                Select Services <span className="text-danger">*</span>
              </label>
              <div className="text-muted" style={{ fontSize: 12 }}>
                {(formData.services || []).length} service(s) selected
              </div>
            </div>
            <div className="mb-3 w-50">
              <input
                type="text"
                className="form-control"
                value={serviceQuery}
                onChange={(e) => setServiceQuery(e.target.value)}
                placeholder="Search services..."
              />
            </div>
            {errors.services && (
              <div className="alert alert-danger py-2" role="alert">
                {errors.services}
              </div>
            )}

            <div
              style={{
                background: "#fcf6f3",
                borderRadius: "14px",
                padding: "14px",
                height: "200px",
                overflow: "auto",
              }}
            >
              {filteredServiceList.map((category) => (
                <div key={category.categoryId} className="mb-3">
                  <div
                    className="fw-semibold mb-2"
                    style={{ color: "#ff6a00" }}
                  >
                    {category.categoryName}
                  </div>
                  <div className="row">
                    {(category.servicedetails || []).map((service) => {
                      const isSelected = (formData.services || []).some(
                        (s) => s.serviceId === service.serviceId
                      );
                      return (
                        <div key={service.serviceId} className="col-md-6">
                          <div className="form-check mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={isSelected}
                              onChange={() =>
                                onToggleService(
                                  service.serviceId,
                                  category.categoryId
                                )
                              }
                              id={`svc_${service.serviceId}`}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`svc_${service.serviceId}`}
                            >
                              {service.serviceName} - {currencyName}{service.fixedAmount}
                            </label>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Service Details */}
        <div className="mt-4">
          <label className="form-label mb-2">Service Details</label>
          <div
            className="border rounded-3 p-3"
            style={{ maxHeight: "500px", overflow: "auto" }}
          >
            {(formData.services || []).map((service, i) => {
              // ADDED: offers for only this service row
              const rowOffers = offerMap?.[service.serviceId] || [];

              return (
                <div
                  key={service.serviceId}
                  className={i > 0 ? "mt-3 pt-3 border-top" : ""}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="fw-semibold">
                      {i + 1}. {getServiceName(service.serviceId)}
                    </div>
                    <button
                      type="button"
                      className="btn btn-link text-danger p-0"
                      title="Remove"
                      onClick={() => onToggleService(service.serviceId)}
                      style={{ textDecoration: "none" }}
                    >
                      <DeleteIcon color="error" />
                    </button>
                  </div>

                  <div className="row g-3 mt-2">
                    {/* Team Member */}
                    <div className="col-md-6 cus-form">
                      <label className="form-label">
                        Team <span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-select form-control ${
                          errors.serviceStaffMap?.[service.serviceId]
                            ? "is-invalid"
                            : ""
                        }`}
                        value={service.staffId || ""}
                        onChange={(e) => {
                          updateServiceDetail(
                            service.serviceId,
                            "staffId",
                            e.target.value
                          );
                          clearServiceStaffError(service.serviceId);
                        }}
                      >
                        <option value="">Select team member</option>
                        {teamMember.map((member) => (
                          <option key={member._id} value={member._id}>
                            {member.name}
                          </option>
                        ))}
                      </select>
                      {errors.serviceStaffMap?.[service.serviceId] && (
                        <div className="invalid-feedback d-block">
                          {errors.serviceStaffMap?.[service.serviceId]}
                        </div>
                      )}
                    </div>

                    {/* Price */}
                    <div className="col-md-6 cus-form">
                      <label className="form-label">Price ({currencyName})</label>
                      <input
                        disabled
                        // type="number"
                        className="form-control"
                        value={service.serviceAmount + `${service?.GST === 'INCLUDE' ? ' (GST INCLUDED)' : ' (GST EXCLUDED)'}` ?? ""}
                      />
                    </div>

                    {/* GST % */}
                    <div className="col-md-6 cus-form">
                      <label className="form-label">GST %</label>
                      <input
                      disabled
                      min={0}
                        type="number"
                        className="form-control"
                          pattern="\d*"
                        value={service.gstPercent ?? ""}
                        onKeyDown={blockNonNumericKeys}
                        onChange={(e) => {
                           const v = digitsOnlyMax(e.target.value, 2);
                          updateServiceDetail(
                            service.serviceId,
                            "gstPercent",
                           v
                          );
                          setTimeout(
                            () => recomputeService(service.serviceId),
                            0
                          );
                        }}
                      />
                    </div>

                    {/* Offer Dropdown */}
                    <div className="col-md-6 cus-form">
                      <label className="form-label">Offer</label>
                      <select
                        className="form-select form-control"
                        value={service.offerId || ""}
                        onChange={(e) =>
                          updateServiceOffer(service.serviceId, e.target.value)
                        }
                      >
                        <option value="">Select offer</option>

                        {/* MODIFIED: use rowOffers instead of offerList */}
                        {rowOffers.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.name} -{" "}
                            {item.discountType === "FLAT"
                              ? `${currencyName}${item.discountValue} off`
                              : `${item.discountValue}% off${
                                  item.maximumValue
                                    ? ` (max ${currencyName}${item.maximumValue})`
                                    : ""
                                }`}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* GST Status */}

                      {/* <div className="col-12">
                      <div className="fw-semibold" style={{ fontSize: 13 }}>
                        GST Status
                      </div>
                      <div 
                        className="mt-1 px-3 py-2" 
                        style={{ 
                          background: "#f8f9fa", 
                          borderRadius: 6,
                          border: "1px solid #dee2e6"
                        }}
                      >
                        <span className="fw-semibold" style={{ color: "#495057" }}>
                          {(service.GST || "EXCLUDE") === "INCLUDE" 
                            ? "Included" 
                            : "Excluded"}
                        </span>
                      </div>
                      
                    </div> */}

                    {/* Offer Details Display */}
                    {service.selectedOffer && service.offerDiscount > 0 && (
                      <div className="col-12">
                        <div
                          className="alert alert-success py-2"
                          role="alert"
                          style={{ fontSize: "13px" }}
                        >
                          <button
                            type="button"
                            className="btn btn-link text-danger p-0 position-absolute"
                            style={{
                              top: 6,
                              right: 10,
                              textDecoration: "none",
                            }}
                            title="Remove offer"
                            onClick={() => clearServiceOffer(service.serviceId)}
                          >
                            <span
                              style={{
                                fontSize: 18,
                                fontWeight: 700,
                                lineHeight: 1,
                              }}
                            >
                              ×
                            </span>
                          </button>
                          <div className="fw-semibold mb-1">
                            Offer Applied: {service.selectedOffer.name}
                          </div>
                          <div className="d-flex justify-content-between">
                            <span>Original Base Price:</span>
                            <span>
                              {formatMoney(service.originalBasePrice)}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between text-success fw-semibold">
                            <span>
                              Discount (
                              {service.selectedOffer.discountType === "FLAT"
                                ? "Flat"
                                : `${service.selectedOffer.discountValue}%`}
                              ):
                            </span>
                            <span>- {formatMoney(service.offerDiscount)}</span>
                          </div>
                          <div className="d-flex justify-content-between fw-semibold">
                            <span>Discounted Base Price:</span>
                            <span>{formatMoney(service.basePrice)}</span>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Price Breakdown */}
                    <div className="col-12">
                      <div
                        style={{
                          background: "#fcf6f3",
                          borderRadius: 10,
                          padding: 12,
                        }}
                      >
                        {formData?.additionalOffer?.discount ?  <div className="d-flex justify-content-between">
                          <div className="text-muted">
                           Additional Discount :
                          </div>
                          <div className="fw-semibold">
                            {formatMoney(service.additionalBasePrice)}
                          </div>
                        </div>  :              <div className="d-flex justify-content-between">
                          <div className="text-muted">
                            Base Price (excl. GST):
                          </div>
                          <div className="fw-semibold">
                            {formatMoney(service.basePrice)}
                          </div>
                        </div> }
           
                        

{formData?.additionalOffer?.discount ?  <div className="d-flex justify-content-between">
                          <div className="text-muted">
                           Additional Discount GST ({service.gstPercent || 0}%):
                          </div>
                          <div className="fw-semibold">
                            {formatMoney(service.additionalGstValue)}
                          </div>
                        </div> :          <div className="d-flex justify-content-between">
                          <div className="text-muted">
                            GST ({service.gstPercent || 0}%):
                          </div>
                          <div className="fw-semibold">
                            {formatMoney(service.gstValue)}
                          </div>
                        </div>}
               

                        {formData?.additionalOffer?.discount ? 
                        <div className="d-flex justify-content-between">
                          <div className="text-muted">Additional Discount Final Price:</div>
                          <div className="fw-semibold">
                            {formatMoney(service.additionalFinalAmount)}
                          </div>
                        </div> :                         <div className="d-flex justify-content-between">
                          <div className="text-muted">Total (incl. GST):</div>
                          <div className="fw-semibold">
                            {formatMoney(service.finalAmount)}
                          </div>
                        </div> }

                      </div>
                    </div>
                  </div>
                </div>
              );
            })}

            {(formData.services || []).length === 0 && (
              <div
                className="d-flex flex-column align-items-center justify-content-center text-center"
                style={{ minHeight: 160 }}
              >
                <div className="fw-semibold" style={{ fontSize: 15 }}>
                  No services selected
                </div>
                <div
                  className="text-muted mt-1"
                  style={{ fontSize: 13, maxWidth: 420 }}
                >
                  Please select at least one service from the list above to add
                  it to this invoice.
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Invoice Summary */}
{(formData.services || []).length > 0 && (
  <div
    className="mt-4 p-4"
    style={{
      background: "#fff7f0",
      borderRadius: 12,
      border: "1px solid #ff6a00",
    }}
  >
    <div className="fw-bold mb-3" style={{ fontSize: 16, color: "#ff6a00" }}>
      Invoice Summary
    </div>

    {/* Original Subtotal */}
    <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
      <div className="text-muted">
        <span style={{ fontSize: "14px" }}>Subtotal (excl. GST)</span>
        <small className="d-block" style={{ fontSize: 11 }}>
          Sum of all service base prices
        </small>
      </div>
      <div className="fw-semibold" style={{ fontSize: 16 }}>
        {formatMoney(totals.subTotal)}
      </div>
    </div>

    {/* Additional Discount Section */}
    <div className="py-3 border-bottom">
      <div className="fw-semibold mb-2" style={{ fontSize: 14 }}>
        Additional Discount
      </div>
      {/* Radio Buttons */}
      <div className="d-flex align-items-center gap-3 mb-2">
        <label 
          className="d-flex align-items-center gap-2" 
          style={{ cursor: 'pointer', fontSize: 14 }}
        >
          <input
            type="radio"
            name="additionalDiscountType"
            checked={formData.additionalOffer?.discountType === 'PERCENTAGE'}
            onChange={() => {
              setFormData(prev => ({
                ...prev,
                additionalOffer: {
                  ...prev.additionalOffer,
                  discountType: 'PERCENTAGE',
                  discount: 0,
                  discountPrice: 0,
                }
              }));
            }}
          />
          <span>Percentage (%)</span>
        </label>
        <label 
          className="d-flex align-items-center gap-2" 
          style={{ cursor: 'pointer', fontSize: 14 }}
        >
          <input
            type="radio"
            name="additionalDiscountType"
            checked={formData.additionalOffer?.discountType === 'FLAT'}
            onChange={() => {
              setFormData(prev => ({
                ...prev,
                additionalOffer: {
                  ...prev.additionalOffer,
                  discountType: 'FLAT',
                  discount: 0,
                  discountPrice: 0,
                }
              }));
            }}
          />
          <span>Flat ({currencyName})</span>
        </label>

        {formData.additionalOffer?.discountType && (
          <button
            type="button"
            className="btn btn-sm btn-link text-danger p-0"
            onClick={() => {
              setFormData(prev => ({
                ...prev,
                additionalOffer: {
                  discountType: null,
                  discount: 0,
                  discountPrice: 0,
                }
              }));
            }}
            style={{ fontSize: 12, textDecoration: 'none' }}
          >
            Clear
          </button>
        )}
      </div>

      {/* Discount Input Field */}
      {formData.additionalOffer?.discountType && (
        <div className="mt-2">
          <div className="row g-2 align-items-center">
            <div className="col-md-4">
              <div className="input-group">
                {formData.additionalOffer?.discountType === 'FLAT' && (
                  <span className="input-group-text">{currencyName}</span>
                )}
                {/* <input
                  type="number"
                  className="form-control"
                  pattern="\d*"
                  maxLength={7}
                  placeholder={`Enter ${formData.additionalOffer?.discountType === 'PERCENTAGE' ? 'percentage' : 'amount'}`}
                  onKeyDown={blockNonNumericKeys}
                  min="0"
                  max={formData.additionalOffer?.discountType === 'PERCENTAGE' ? '100' : totals.subTotal}
                  value={formData.additionalOffer?.discount || ''}
                  onChange={(e) => {
                    // const value = e.target.value;
                      const value = digitsOnlyMax(e.target.value, 7);
                    setFormData(prev => ({
                      ...prev,
                      additionalOffer: {
                        ...prev.additionalOffer,
                        discount: value ? Number(value) : 0,
                      }
                    }));
                  }}
                /> */}

<input
  type="number"
  step="0.01"
  className="form-control"
  min="0"
  max={formData.additionalOffer?.discountType === 'PERCENTAGE' ? '100' : totals.subTotal}
  placeholder={`Enter ${
    formData.additionalOffer?.discountType === 'PERCENTAGE'
      ? 'percentage'
      : 'amount'
  }`}
  value={formData.additionalOffer?.discount || ''}
  onChange={(e) => {
    let value = e.target.value;
    // Block -- and ++ and allow only valid decimal numbers
    if (!/^\d*\.?\d*$/.test(value)) return;
    
    if (value === '') {
      setFormData(prev => ({
        ...prev,
        additionalOffer: {
          ...prev.additionalOffer,
          discount: '',
        }
      }));
      return;
    }

    let numValue = Number(value);
    if (formData.additionalOffer?.discountType === 'PERCENTAGE') {
      if (numValue > 100) {
        numValue = 100;
      }
      const valueStr = String(numValue);
      const [intPart] = valueStr.split('.');
      if (intPart && intPart.length > 3) {
        return; 
      }
    }
    
    if (formData.additionalOffer?.discountType === 'FLAT') {
      const services = formData.services || [];
      let actualTotal = 0;
      for (const service of services) {
        actualTotal += (service.basePrice || 0) + (service.gstValue || 0);
      }
      
      if (numValue > actualTotal) {
        numValue = actualTotal;
      }
    }

    setFormData(prev => ({
      ...prev,
      additionalOffer: {
        ...prev.additionalOffer,
        discount: numValue,
      }
    }));
  }}
  onKeyDown={(e) => {
    // Block increment/decrement arrow keys
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
    }
    // Block +, -, and e (scientific notation)
    if (e.key === '+' || e.key === '-' || e.key === 'e' || e.key === 'E') {
      e.preventDefault();
    }
  }}
  onBlur={(e) => {
    if (formData.additionalOffer?.discountType === 'FLAT') {
      const services = formData.services || [];
      let actualTotal = 0;
      for (const service of services) {
        actualTotal += (service.basePrice || 0) + (service.gstValue || 0);
      }
      
      const currentDiscount = Number(formData.additionalOffer?.discount || 0);
      if (currentDiscount > actualTotal) {
        setFormData(prev => ({
          ...prev,
          additionalOffer: {
            ...prev.additionalOffer,
            discount: actualTotal,
          }
        }));
      }
    }
  }}
  style={{
    // Hide spinner arrows in Chrome, Safari, Edge, Opera
    MozAppearance: 'textfield',
  }}
  onWheel={(e) => e.target.blur()} // Prevent scroll to change value
/>

                {formData.additionalOffer?.discountType === 'PERCENTAGE' && (
                  <span className="input-group-text">%</span>
                )}
              </div>
            </div>
          </div>

          {/* Discount Display */}
          {totals.additionalDiscount > 0 && (
            <div className="mt-2 p-2" style={{ background: '#f0f9ff', borderRadius: 6 }}>
              <div className="d-flex justify-content-between align-items-center">
                <span style={{ fontSize: 13, color: '#0369a1' }}>
                  <strong>Discount Applied:</strong>
                  {formData.additionalOffer?.discountType === 'PERCENTAGE' 
                    ? ` ${formData.additionalOffer?.discount}%`
                    : ' Flat'}
                </span>
                <span style={{ fontSize: 13, color: '#0369a1', fontWeight: 600 }}>
                  - {formatMoney(totals.additionalDiscount)}
                </span>
              </div>
            </div>
          )}
        </div>
      )}
    </div>

    {/* Discounted Subtotal (if discount applied) */}
    {totals.additionalDiscount > 0 && (
      <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
        <div className="text-muted">
          <span style={{ fontSize: "14px" }}>Discounted Subtotal</span>
          <small className="d-block" style={{ fontSize: 11 }}>
            After additional discount
          </small>
        </div>
        <div className="fw-semibold" style={{ fontSize: 16, color: '#059669' }}>
          {formatMoney(totals.discountedSubTotal)}
        </div>
      </div>
    )}

    {/* Total GST */}
    <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
      <div className="text-muted">
        <span style={{ fontSize: "14px" }}>Total GST</span>
        <small className="d-block" style={{ fontSize: 11 }}>
          {totals.additionalDiscount > 0 
            ? 'Calculated on discounted subtotal'
            : 'Sum of all GST amounts'}
        </small>
      </div>
      <div className="fw-semibold" style={{ fontSize: 16 }}>
        {formatMoney(totals.totalGst)}
      </div>
    </div>

    {/* Total Amount */}
    <div className="d-flex justify-content-between align-items-center pt-3">
      <div className="fw-bold" style={{ fontSize: 15 }}>
        Total Amount (incl. GST)
        <small
          className="d-block text-muted"
          style={{ fontSize: 11, fontWeight: 400 }}
        >
          Final payable amount
        </small>
      </div>
      <div
        className="fw-bold"
        style={{ fontSize: 18, color: "#ff6a00" }}
      >
        {formatMoney(totals.totalAmount)}
      </div>
    </div>

    {/* Savings Summary (if discount applied) */}
    {totals.additionalDiscount > 0 && (
      <div className="mt-3 p-2" style={{ background: '#dcfce7', borderRadius: 8 }}>
        <div className="text-center" style={{ fontSize: 13, color: '#166534', fontWeight: 600 }}>
          🎉 You saved {formatMoney(totals.additionalDiscount)} with additional discount!
        </div>
      </div>
    )}
  </div>
)}

  <div className="mt-4">
  <div className="row g-3">
    {/* Payment Mode */}
    <div className="col-md-6 cus-form">
      <label className="form-label">
        Payment Mode <span className="text-danger">*</span>
      </label>
      <select
        className={`form-select form-control ${
          errors.paymentMode ? "is-invalid" : ""
        }`}
        name="paymentMode"
        value={formData.paymentMode || ""}
        onChange={(e) => {
          const value = e.target.value;
          setFormData((prev) => ({
            ...prev,
            paymentMode: value,
            // Reset paymentType when changing payment mode
            paymentType: value === "CASH" ? null : prev.paymentType,
          }));
          removeErrorKey("paymentMode");
          // Clear paymentType error if switching to CASH
          if (value === "CASH") {
            removeErrorKey("paymentType");
          }
        }}
      >
        <option value="" disabled>
          Select payment mode
        </option>
        <option value="CASH">Cash</option>
        <option value="ONLINE">Online</option>
      </select>
      {errors.paymentMode && (
        <div className="invalid-feedback d-block">
          {errors.paymentMode}
        </div>
      )}
    </div>

    {/* Payment Type - Only show when ONLINE is selected */}
    {formData.paymentMode === "ONLINE" && (
      <div className="col-md-6 cus-form">
        <label className="form-label">
          Payment Type <span className="text-danger">*</span>
        </label>
        <select
          className={`form-select form-control ${
            errors.paymentType ? "is-invalid" : ""
          }`}
          name="paymentType"
          value={formData.paymentType || ""}
          onChange={(e) => {
            setFormData((prev) => ({
              ...prev,
              paymentType: e.target.value,
            }));
            removeErrorKey("paymentType");
          }}
        >
          <option value="" disabled>
            Select payment type
          </option>
          <option value="UPI">UPI</option>
          <option value="CARD">Card</option>
        </select>
        {errors.paymentType && (
          <div className="invalid-feedback d-block">
            {errors.paymentType}
          </div>
        )}
      </div>
    )}
  </div>
</div>

        {/* Share Options */}
        <div className="mt-4">
          <div className="fw-semibold mb-2">
            Share Options <span className="text-danger">*</span>
          </div>
          <div style={{ background: "#fcf6f3", borderRadius: 10, padding: 14 }}>
            {/* EMAIL */}
            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="checkbox"
                id="send_email"
                checked={isTypeSelected("EMAIL")}
                onChange={() => toggleSendType("EMAIL")}
              />
              <label className="form-check-label" htmlFor="send_email">
                <MailOutlineIcon
                  style={{ color: "#ff6a00", fontSize: "1.2rem" }}
                />{" "}
                Share via Email
              </label>
            </div>
            {isTypeSelected("EMAIL") && (
              <div className="ms-4 mb-2">
                <label className="form-label mb-1">
                  Email <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                  value={
                    (formData.sendType || []).find((x) => x.type === "EMAIL")
                      ?.email || ""
                  }
                  onChange={(e) => updateEmailInSendType(e.target.value)}
                  placeholder="Enter email"
                />
                {errors.email && (
                  <div className="invalid-feedback d-block">{errors.email}</div>
                )}
              </div>
            )}

            {/* WHATSAPP */}
            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="checkbox"
                id="send_wa"
                checked={isTypeSelected("WHATSAPP")}
                onChange={() => toggleSendType("WHATSAPP")}
              />
              <label className="form-check-label" htmlFor="send_wa">
                <WhatsAppIcon
                  style={{ color: "#08CB00", fontSize: "1.2rem" }}
                />{" "}
                Share via WhatsApp
              </label>
            </div>

            {/* SMS */}
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="send_sms"
                checked={isTypeSelected("SMS")}
                onChange={() => toggleSendType("SMS")}
              />
              <label className="form-check-label" htmlFor="send_sms">
                <SmsIcon style={{ color: "#758A93", fontSize: "1.2rem" }} />{" "}
                Share via SMS
              </label>
            </div>

            {errors.sendType && (
              <div className="text-danger mt-2">{errors.sendType}</div>
            )}
          </div>

          {/* Generate Button */}
          <div className="d-flex justify-content-end mt-3">
            <button
              type="button"
              className="btn text-white px-4"
              onClick={onGenerate}
              style={{
                borderRadius: 8,
                fontWeight: 600,
                backgroundColor: "#ff6a00",
                opacity: spinner ? 0.7 : 1,
                cursor: spinner ? "not-allowed" : "pointer",
              }}
              disabled={spinner}
            >
              {spinner ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  ></span>
                  Generating...
                </>
              ) : (
                <>
                  <SaveAltIcon /> Generate Invoice
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoiceForm;
